<template>
    <Modal2 title="" :visible="true" @cancel="closeModal" class="voice-assistant-modal">
        <template v-slot:title>
            <div class="d-flex gap-5 title">
                <img src="/static/img/copilot.png" />
                <h2>Bu Sayfada Sesli Asistanı Var</h2>
            </div>
        </template>
        <div class="voice-assistant-content">
            <h2>Merhaba! {{ user.name }} 👋</h2>
            <p>
                Bu sayfada size yardımcı olacak bir <strong>Yapay Zeka Asistanı</strong> olduğunu biliyor muydun?.
                Asistanı kullanmak için aşağıdaki yöntemleri deneyebilirsiniz:
            </p>
            <ul>
                <li><strong>CTRL + "</strong> tuş kombinasyonuna basılı tutup konuşarak komut verebilirsiniz.</li>
                <li>
                    Sağ üst köşedeki <img src="/static/img/copilot.png" width="40" height="40" /> simgesine tıklayarak
                    asistanı başlatabilirsiniz.
                </li>
            </ul>
            <div class="manual-main-content">
                <div class="voice-commands">
                    <h3>Örnek Sesli Komutlar:</h3>
                    <ul>
                        <li>"Benim ticketlarımı göster."</li>
                        <li>"Bugünkü Zeynep'in açık ticketlarını göster."</li>
                        <li>"Ekrandaki ticketları sil."</li>
                        <li>"Sonuncu ticket'ı Ali'ye ata."</li>
                        <li>"Tüm ticketların durumunu yapıldı olarak değiştir."</li>
                        <li>"Ekrandaki ticketların durumları ...... olarak ayarla."</li>
                        <li>"Ekrandaki ticketlara .... kullanıcısına ata."</li>
                        <li>"İlk ticket'ı bana ata."</li>
                        <li>"Geçen ayki instagram ticketlarını göster."</li>
                    </ul>
                </div>
                <img src="https://static.supsis.live/common/image/ticket-copilot.gif" />
            </div>
            <div class="assistant-animation">
                <!-- Animasyon veya görsel içerik buraya gelebilir -->
            </div>
        </div>
    </Modal2>
</template>
<script>
import Vue from "vue";
import Modal2 from "../../../../components/common/Modal2.vue";
import { mapState } from "vuex";

export default Vue.extend({
    name: "TicketVoiceAssistantManual",
    components: {
        Modal2,
    },
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
        }),
    },
    methods: {
        closeModal() {
            this.$emit("close");
        },
    },
});
</script>
<style scoped lang="scss">
.voice-assistant-modal {
    .voice-assistant-content {
        text-align: center;

        h2 {
            font-size: 24px;
            margin-bottom: 20px;
        }

        p {
            font-size: 16px;
            margin-bottom: 20px;
        }

        ul {
            list-style: none;
            padding: 0;

            li {
                font-size: 16px;
                margin: 10px 0;

                i {
                    margin-right: 8px;
                }
            }
        }

        .voice-commands {
            background-color: #f0f8ff;
            padding: 20px;
            border-radius: 8px;
            margin: 20px 0;

            h3 {
                font-size: 20px;
                margin-bottom: 10px;
            }

            ul {
                li {
                    font-size: 16px;
                    margin: 5px 0;

                    &:before {
                        content: "🔹";
                        margin-right: 8px;
                    }
                }
            }
        }

        .assistant-animation {
            margin-top: 20px;

            img {
                max-width: 100%;
                height: auto;
            }
        }
    }
}
</style>
<style>
.voice-assistant-modal {
    .ant-modal {
        width: 90vw !important;
    }

    .title {
        font-weight: 700;
        color: var(--color-text-strong-default);
        font-size: 24px;
        line-height: 32px;
        display: flex;
        align-items: center;
        gap: 5px;

        h2 {
            margin: 0 !important;
        }

        img {
            width: 40px;
            height: 40px;
        }
    }

    .manual-main-content {
        display: flex;
        gap: 20px;
    }
}
</style>
